import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Box } from '@mui/material';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        if (!accounts || accounts.length === 0) {
            // If not logged in, show the message
            setShowMessage(true);

            // Delay the loginRedirect to allow the message to show
            setTimeout(() => {
                // Trigger the MSAL login flow after a delay
                instance.loginRedirect();
            }, 1000000000);
        }
    }, [accounts, instance, navigate]);

    // If logged in, render the protected component (children)
    return accounts && accounts.length > 0 ? (
        children
    ) : (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center',
                p: 3
            }}
        >
            {showMessage && (
                <Box>
                    <Typography variant="h4" gutterBottom>
                        Authentication Required
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You must be signed in to view the events
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => instance.loginRedirect()}
                        sx={{
                            backgroundColor: 'green',
                            '&:hover': { backgroundColor: 'darkgreen' },
                            mt: 2
                        }}
                    >
                        Sign In
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default ProtectedRoute;